import { Form } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { DatePickerPlain } from "../../../../../../../_shared/time/components/DatePickerPlain";
import { TicketMetaField } from "../../../../../../administration/ticket_creation/types/field_configs/Meta";

type Props = {
  field: Extract<TicketMetaField, { type: "date" }>;
  name: string;
};

export const DateInput = observer((props: Props) => {
  return (
    <Form.Item
      name={props.name}
      label={props.field.label}
      help={props.field.description}
    >
      <DatePickerPlain />
    </Form.Item>
  );
});
